export * from "./hero-image-text-side";
export { HeroImageTextSide as default } from "./hero-image-text-side";
